var $b1bf14102833c31a$exports = {};
$b1bf14102833c31a$exports = {
    "collapse": `Sbalit`,
    "expand": `Rozt\xe1hnout`
};


export {$b1bf14102833c31a$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
